import type {FieldValue} from "./types";
import {CheckedStatusEnum} from "./types";

export const TOOLTIP_LENGTH_DEFAULT = 22;

/** Faded checklist checkbox square: compact rows vs modal / roomy contexts. */
export const TASK_CHECKBOX_BOX_PX = {
  normal: 14,
  large: 16,
} as const;

export const DATE_RANGE_BEFORE_YEARS = 15;
export const DATE_RANGE_AFTER_YEARS = 1;

export const emptyChecklistItem: FieldValue = {
  checked: false,
  checkedDate: null,
  checkedStatus: CheckedStatusEnum.OPEN,
};

export const emptyChecklistItemWithStatus: FieldValue = {
  ...emptyChecklistItem,
  checkedStatus: CheckedStatusEnum.OPEN,
};
